import { Component, OnInit } from '@angular/core';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import { Router,ActivatedRoute  } from '@angular/router';
import {ConstantsService} from '../common/services/constants.service';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import * as $ from 'jquery';
import xml2js from 'xml2js';
declare var show_okshan_alert: Function;
declare var show_okshan_alert3: Function;
declare var manage_show_hide_inspection_detail: Function;
declare var show_img: Function;
declare var show_img2: Function;
declare var hide_modal: Function;

@Component({
  selector: 'app-auction-car-detail',
  templateUrl: './auction-car-detail.component.html',
  styleUrls: ['./auction-car-detail.component.css']
})
export class AuctionCarDetailComponent implements OnInit {

  fileUrl;
  id;
  carDetail;
  sessionId;
  actionStatus:boolean=false;  
  sessionProfileType:number=-1;

  basicList;
  exteriorFrontList=[];
  exteriorOtherList=[];
  tyresList=[];
  engineList=[];
  aCList=[];
  interiorList=[];
  sSBList=[];
  documentList=[];
  okshanDetailList=[];
  timerList=[];
  highlights=[];
  coolingSystemList=[];
  otherInspectionDetailsList;
  carHighlights;
  inspectionDetailStatus:boolean=false;
  ratingCar:number=0;
  exteriorFrontXML;
  exteriorOtherXML;
  tyresXML;
  engineXML;
  interiorXML;
  aCXML;
  sSBXML;
  documentXML;
  coolingSystemXML;

  bidFormGroup;
  isSubmitBid:boolean=false;
  bidBTNLabel:string='Save';

  joinOkshanFormGroup;
  isSubmitJoinOkshan:boolean=false;
  joinOkshanBTNLabel:string='Save';

  bidSecurityAmount:any=0;
  minBidAmount:any=0;
  highestBidAmount:any=0;
  bidMsg:string='';

  constructor(private httpserviceService:HttpserviceService,private sessionsService:SessionsService,private router:Router,private _constant: ConstantsService,private route:ActivatedRoute) { }

  ngOnInit(): void { 
    if(this.sessionsService.getSession("login_status")==null)
    {       
         window.location.href="#/visitor";       
    }
    else if(!this.sessionsService.getSession("login_status"))
       {
         window.location.href="#/visitor";
       }
    window.scrollTo(0, 0);
    this.sessionId=this.sessionsService.getSession("id");
    if(this.sessionsService.getSession("profile_type")!=null && this.sessionsService.getSession("status")!=null)
    {
       if(this.sessionsService.getSession("profile_type")!=-1 && this.sessionsService.getSession("status")==1)
       {
         this.actionStatus=true;
       }
    }    
   if(this.sessionsService.getSession("profile_type")!=null)
    {
       this.sessionProfileType=this.sessionsService.getSession("profile_type");
    }
    //show_okshan_alert(this.route.snapshot.queryParamMap.get('id'));
    this.id=this.route.snapshot.queryParamMap.get('id');
    //this.fileUrl=this._constant.uploadFileUrl;
    //aws server url for upload and get changes
    this.fileUrl=this._constant.uploadFileUrlForAWS;

    this.bidFormGroup= new  FormGroup( 
      { 
      bidAmount: new FormControl("",[Validators.required]),      
      }
    );

    this.joinOkshanFormGroup= new  FormGroup( 
      { 
      joinOkshanSecurity: new FormControl("",[Validators.required]),
      }
    );

    setTimeout(() => {
      this.loadExteriorFrontXML();
      this.loadExteriorOtherXML();
      this.loadTyresXML();
      this.loadEngineXML();
      this.loadInteriorXML();
      this.loadACXML();
      this.loadSSBXML();
      this.loadDocumentXML();
      this.loadCoolingSystemXML();
      this.getCarDetail();
      }, 50);
    setTimeout(() => {
      manage_show_hide_inspection_detail();
    }, 1000);
  }

  /** getCarDetail function used to get car detail  */
  getCarDetail()
  {
    let result =this.httpserviceService.carDetailRequest(this.id).
     pipe(retry(0)).
     subscribe((data)=>this.carDetailResponse(data),
     err => {
       //show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** carDetailResponse function used to handle response */
  carDetailResponse(response)
  {
    console.log('carListResponse '+ response);
    if(response.status==="success")  
     {       
       this.carDetail=response.detail;  
       this.setOkshanDetail();
       this.getInspectionDetail();       
     }
     else
     {
     show_okshan_alert(response.reason);
     } 
  }

  /** getModelFromId function used to get model from id  */
   getModelFromId(id)
   {
     if(this.sessionsService.getSession('all_model_list')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_model_list');     
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   }

   /** getVariantFromId function used to get variant from id  */
   getVariantFromId(id)
   {     
     if(this.sessionsService.getSession('all_variant_list')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_variant_list');         
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   }

   /** getInspectionDetail function used to get inspection detail */
  getInspectionDetail()
  {
     let body = { profile_id: this.sessionsService.getSession('id'),car_id:this.id};
     
     
     let result =this.httpserviceService.getInspectionDetailRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.getInspectionDetailResponse(data), 
     err => {
       //show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })    
  }

  

  /** getInspectionDetailResponse method used to handle response */
  getInspectionDetailResponse(response)
  {
    console.log('getInspectionDetailResponse '+ response.status);
    if(response.status==="success")  
     {

       if(response.car_exterior_front[0])
       {
         let detail=response.car_exterior_front[0];
         for(let i=0;i<this.exteriorFrontXML.length;i++)
         { 
         if(detail["detail_"+(i+1)] && i!=24 && i!=25) 
         {  
             let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",}      
             if(detail["detail_"+(i+1)]) 
              {
               let detailsArray=detail["detail_"+(i+1)].split("@#^")
               if(detailsArray[0])
               {
                let optionsArray=detailsArray[0].split(",");
                let optionsLabel="";
                for(let j=0;j<optionsArray.length;j++)
                {
                  if(this.exteriorFrontXML[i].optionList)
                  {
                  if(this.exteriorFrontXML[i].optionList[optionsArray[j]])
                    {
                      //console.log(" option "+(i+1)+" "+(this.exteriorFrontXML[i].optionList[optionsArray[j]])); 
                      optionsLabel=optionsLabel+" "+this.exteriorFrontXML[i].optionList[optionsArray[j]];
                    } 
                  }
                }
                optionDetail["option"]=optionsLabel;
               }
               if(detailsArray[1])
               { 
                 optionDetail["content"]=detailsArray[1];
               }
               if(detailsArray[2])
               { 
                 optionDetail["image"]=detailsArray[2];
               }
               optionDetail["label"]=this.exteriorFrontXML[i].name
               optionDetail["text"]=this.exteriorFrontXML[i].text
               optionDetail["pic"]=this.exteriorFrontXML[i].pic
              }
              this.exteriorFrontList.push(optionDetail);
            } else {
              let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",}      
               if(detail["detail_"+(i+2)]) 
                {
                 let detailsArray=detail["detail_"+(i+2)].split("@#^")
                 if(detailsArray[0])
                 {
                  let optionsArray=detailsArray[0].split(",");
                  let optionsLabel="";
                  for(let j=0;j<optionsArray.length;j++)
                  {
                    if(this.exteriorFrontXML[i].optionList)
                    {
                    if(this.exteriorFrontXML[i].optionList[optionsArray[j]])
                      {
                        //console.log(" option "+(i+1)+" "+(this.exteriorFrontXML[i].optionList[optionsArray[j]])); 
                        optionsLabel=optionsLabel+" "+this.exteriorFrontXML[i].optionList[optionsArray[j]];
                      } 
                    }
                  }
                  optionDetail["option"]=optionsLabel;
                 }
                 if(detailsArray[1])
                 { 
                   optionDetail["content"]=detailsArray[1];
                 }
                 if(detailsArray[2])
                 { 
                   optionDetail["image"]=detailsArray[2];
                 }
                 optionDetail["label"]=this.exteriorFrontXML[i].name
                 optionDetail["text"]=this.exteriorFrontXML[i].text
                 optionDetail["pic"]=this.exteriorFrontXML[i].pic
                }
                this.exteriorFrontList.push(optionDetail);
            }
         }         
       }

       if(response.car_exterior_other[0])
       {
         let detail=response.car_exterior_other[0];
         for(let i=0;i<this.exteriorOtherXML.length;i++)
         {
         if(detail["detail_"+(i+1)] && i!=20 && i!=21 && i!=22) 
         {   
             let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",}      
             if(detail["detail_"+(i+1)]) 
              {
               let detailsArray=detail["detail_"+(i+1)].split("@#^")
               if(detailsArray[0])
               {
                let optionsArray=detailsArray[0].split(",");
                let optionsLabel="";
                for(let j=0;j<optionsArray.length;j++)
                {
                  if(this.exteriorOtherXML[i].optionList)
                  {
                  if(this.exteriorOtherXML[i].optionList[optionsArray[j]])
                    {
                      //console.log(" option "+(i+1)+" "+(this.exteriorOtherXML[i].optionList[optionsArray[j]])); 
                      optionsLabel=optionsLabel+" "+this.exteriorOtherXML[i].optionList[optionsArray[j]];
                    } 
                  }
                }
                optionDetail["option"]=optionsLabel;
               }
               if(detailsArray[1])
               { 
                 optionDetail["content"]=detailsArray[1];
               }
               if(detailsArray[2])
               { 
                 optionDetail["image"]=detailsArray[2];
               }
               optionDetail["label"]=this.exteriorOtherXML[i].name
               optionDetail["text"]=this.exteriorOtherXML[i].text
               optionDetail["pic"]=this.exteriorOtherXML[i].pic
              }
              this.exteriorOtherList.push(optionDetail);
          } else {
             let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",}      
             if(detail["detail_"+(i+2)]) 
             {
               let detailsArray=detail["detail_"+(i+2)].split("@#^")
               if(detailsArray[0])
               {
                let optionsArray=detailsArray[0].split(",");
                let optionsLabel="";
                for(let j=0;j<optionsArray.length;j++)
                {
                  if(this.exteriorOtherXML[i].optionList)
                  {
                  if(this.exteriorOtherXML[i].optionList[optionsArray[j]])
                    {
                      //console.log(" option "+(i+2)+" "+(this.exteriorOtherXML[i].optionList[optionsArray[j]])); 
                      optionsLabel=optionsLabel+" "+this.exteriorOtherXML[i].optionList[optionsArray[j]];
                    } 
                  }
                }
                optionDetail["option"]=optionsLabel;
               }
               if(detailsArray[1])
               { 
                 optionDetail["content"]=detailsArray[1];
               }
               if(detailsArray[2])
               { 
                 optionDetail["image"]=detailsArray[2];
               }
               optionDetail["label"]=this.exteriorOtherXML[i].name
               optionDetail["text"]=this.exteriorOtherXML[i].text
               optionDetail["pic"]=this.exteriorOtherXML[i].pic
              }
              this.exteriorOtherList.push(optionDetail);
          }
        }     
       }

       if(response.car_tyres[0])
       {
         let detail=response.car_tyres[0];
         for(let i=0;i<this.tyresXML.length;i++)
         {   
         let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",}      
         if(detail["detail_"+(i+1)]) 
          {
           let detailsArray=detail["detail_"+(i+1)].split("@#^")
           if(detailsArray[0])
           {
            let optionsArray=detailsArray[0].split(",");
            let optionsLabel="";
            for(let j=0;j<optionsArray.length;j++)
            {
              if(this.tyresXML[i].optionList)
              {
              if(this.tyresXML[i].optionList[optionsArray[j]])
                {
                  //console.log(" option "+(i+1)+" "+(this.tyresXML[i].optionList[optionsArray[j]])); 
                  optionsLabel=optionsLabel+" "+this.tyresXML[i].optionList[optionsArray[j]];
                } 
              }
            }
            optionDetail["option"]=optionsLabel;
           }
           if(detailsArray[1])
           { 
             optionDetail["content"]=detailsArray[1];
           }
           if(detailsArray[2])
           { 
             optionDetail["image"]=detailsArray[2];
           }
           optionDetail["label"]=this.tyresXML[i].name
           optionDetail["text"]=this.tyresXML[i].text
           optionDetail["pic"]=this.tyresXML[i].pic
          }
          this.tyresList.push(optionDetail);
         }         
       }

       if(response.car_engine_detail[0])
       {
         let detail=response.car_engine_detail[0];
         for(let i=0;i<this.engineXML.length;i++)
         {   
         let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",}      
         if(detail["detail_"+(i+1)]) 
          {
           let detailsArray=detail["detail_"+(i+1)].split("@#^")
           if(detailsArray[0])
           {
            let optionsArray=detailsArray[0].split(",");
            let optionsLabel="";
            for(let j=0;j<optionsArray.length;j++)
            {
              if(this.engineXML[i].optionList)
              {
              if(this.engineXML[i].optionList[optionsArray[j]])
                {
                  //console.log(" option "+(i+1)+" "+(this.engineXML[i].optionList[optionsArray[j]])); 
                  optionsLabel=optionsLabel+" "+this.engineXML[i].optionList[optionsArray[j]];
                } 
              }
            }
            optionDetail["option"]=optionsLabel;
           }
           if(detailsArray[1])
           { 
             optionDetail["content"]=detailsArray[1];
           }
           if(detailsArray[2])
           { 
             optionDetail["image"]=detailsArray[2];
           }
           optionDetail["label"]=this.engineXML[i].name
           optionDetail["text"]=this.engineXML[i].text
           optionDetail["pic"]=this.engineXML[i].pic
          }
          this.engineList.push(optionDetail);
         }         
       }

       if(response.car_air_condition[0])
       {
         let detail=response.car_air_condition[0];
         for(let i=0;i<this.aCXML.length;i++)
         {   
         let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",}      
         if(detail["detail_"+(i+1)]) 
          {
           let detailsArray=detail["detail_"+(i+1)].split("@#^")
           if(detailsArray[0])
           {
            let optionsArray=detailsArray[0].split(",");
            let optionsLabel="";
            for(let j=0;j<optionsArray.length;j++)
            {
              if(this.aCXML[i].optionList)
              {
              if(this.aCXML[i].optionList[optionsArray[j]])
                {
                  //console.log(" option "+(i+1)+" "+(this.aCXML[i].optionList[optionsArray[j]])); 
                  optionsLabel=optionsLabel+" "+this.aCXML[i].optionList[optionsArray[j]];
                } 
              }
            }
            optionDetail["option"]=optionsLabel;
           }
           if(detailsArray[1])
           { 
             optionDetail["content"]=detailsArray[1];
           }
           if(detailsArray[2])
           { 
             optionDetail["image"]=detailsArray[2];
           }
           optionDetail["label"]=this.aCXML[i].name
           optionDetail["text"]=this.aCXML[i].text
           optionDetail["pic"]=this.aCXML[i].pic
          }
          this.aCList.push(optionDetail);
         }         
       }

       if(response.car_interior_detail[0])
       {
         let detail=response.car_interior_detail[0];
         for(let i=0;i<this.interiorXML.length;i++)
         {   
         let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",}      
         if(detail["detail_"+(i+1)]) 
          {
           let detailsArray=detail["detail_"+(i+1)].split("@#^")
           if(detailsArray[0])
           {
            let optionsArray=detailsArray[0].split(",");
            let optionsLabel="";
            for(let j=0;j<optionsArray.length;j++)
            {
              if(this.interiorXML[i].optionList)
              {
              if(this.interiorXML[i].optionList[optionsArray[j]])
                {
                  //console.log(" option "+(i+1)+" "+(this.interiorXML[i].optionList[optionsArray[j]])); 
                  optionsLabel=optionsLabel+" "+this.interiorXML[i].optionList[optionsArray[j]];
                } 
              }
            }
            optionDetail["option"]=optionsLabel;
           }
           if(detailsArray[1])
           { 
             optionDetail["content"]=detailsArray[1];
           }
           if(detailsArray[2])
           { 
             optionDetail["image"]=detailsArray[2];
           }
           optionDetail["label"]=this.interiorXML[i].name
           optionDetail["text"]=this.interiorXML[i].text
           optionDetail["pic"]=this.interiorXML[i].pic
          }
          this.interiorList.push(optionDetail);
         }         
       }

       if(response.car_brakes[0])
       {
         let detail=response.car_brakes[0];
         for(let i=0;i<this.sSBXML.length;i++)
         {   
         let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",}      
         if(detail["detail_"+(i+1)]) 
          {
           let detailsArray=detail["detail_"+(i+1)].split("@#^")
           if(detailsArray[0])
           {
            let optionsArray=detailsArray[0].split(",");
            let optionsLabel="";
            for(let j=0;j<optionsArray.length;j++)
            {
              if(this.sSBXML[i].optionList)
              {
              if(this.sSBXML[i].optionList[optionsArray[j]])
                {
                  //console.log(" option "+(i+1)+" "+(this.sSBXML[i].optionList[optionsArray[j]])); 
                  optionsLabel=optionsLabel+" "+this.sSBXML[i].optionList[optionsArray[j]];
                } 
              }
            }
            optionDetail["option"]=optionsLabel;
           }
           if(detailsArray[1])
           { 
             optionDetail["content"]=detailsArray[1];
           }
           if(detailsArray[2])
           { 
             optionDetail["image"]=detailsArray[2];
           }
           optionDetail["label"]=this.sSBXML[i].name
           optionDetail["text"]=this.sSBXML[i].text
           optionDetail["pic"]=this.sSBXML[i].pic
          }
          this.sSBList.push(optionDetail);
         }         
       }
       

       if(response.document_list[0])
       {
         let detail=response.document_list[0];
         if(detail["st"]=="Inspection Pending") { 
           for(let i=0;i<this.documentXML.length;i++)
           {       
            if(detail["detail_"+(i+1)] && i!=20 && i!=21 && i!=22 && i!=23 && i!=24 && i!=25 ) 
            {
             let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",} 
             let detailsArray=detail["detail_"+(i+1)].split("@#^")
             if(detailsArray[0])
             {
              let optionsArray=detailsArray[0].split(",");
              let optionsLabel="";
              for(let j=0;j<optionsArray.length;j++)
              {
                if(this.documentXML[i].optionList)
                {
                if(this.documentXML[i].optionList[optionsArray[j]])
                  {
                    //console.log(" option "+(i+1)+" "+(this.sSBXML[i].optionList[optionsArray[j]])); 
                    optionsLabel=optionsLabel+" "+this.documentXML[i].optionList[optionsArray[j]];
                  } 
                }
              }
              optionDetail["option"]=optionsLabel;
             }
             if(detailsArray[1])
             { 
               optionDetail["content"]=detailsArray[1];
             }
             if(detailsArray[2])
             { 
               optionDetail["image"]=detailsArray[2];
             }            
              var textOption=this.documentXML[i].text;
              var textType="";
              if(textOption.texttype)
              {
                textType=textOption.texttype   
              }
             optionDetail["label"]=this.documentXML[i].name
             optionDetail["text"]=textType
             optionDetail["pic"]=this.documentXML[i].pic
             this.documentList.push(optionDetail);
            } else {
               let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",} 
               let detailsArray=detail["detail_"+(i+2)].split("@#^")
               if(detailsArray[0])
               {
                let optionsArray=detailsArray[0].split(",");
                let optionsLabel="";
                for(let j=0;j<optionsArray.length;j++)
                {
                  if(this.documentXML[i].optionList)
                  {
                  if(this.documentXML[i].optionList[optionsArray[j]])
                    {
                      //console.log(" option "+(i+1)+" "+(this.sSBXML[i].optionList[optionsArray[j]])); 
                      optionsLabel=optionsLabel+" "+this.documentXML[i].optionList[optionsArray[j]];
                    } 
                  }
                }
                optionDetail["option"]=optionsLabel;
               }
               if(detailsArray[1])
               { 
                 optionDetail["content"]=detailsArray[1];
               }
               if(detailsArray[2])
               { 
                 optionDetail["image"]=detailsArray[2];
               }            
                var textOption=this.documentXML[i].text;
                var textType="";
                if(textOption.texttype)
                {
                  textType=textOption.texttype   
                }
               optionDetail["label"]=this.documentXML[i].name
               optionDetail["text"]=textType
               optionDetail["pic"]=this.documentXML[i].pic
               this.documentList.push(optionDetail);
            }
           }
         } else {
           for(let i=0;i<this.documentXML.length;i++)
           {       
            if(detail["detail_"+(i+1)] && i!=20 && i!=21 && i!=22 && i!=23 && i!=24 && i!=25 && i!=0) 
            {
             let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",} 
             let detailsArray=detail["detail_"+(i+1)].split("@#^")
             if(detailsArray[0])
             {
              let optionsArray=detailsArray[0].split(",");
              let optionsLabel="";
              for(let j=0;j<optionsArray.length;j++)
              {
                if(this.documentXML[i].optionList)
                {
                if(this.documentXML[i].optionList[optionsArray[j]])
                  {
                    //console.log(" option "+(i+1)+" "+(this.sSBXML[i].optionList[optionsArray[j]])); 
                    optionsLabel=optionsLabel+" "+this.documentXML[i].optionList[optionsArray[j]];
                  } 
                }
              }
              optionDetail["option"]=optionsLabel;
             }
             if(detailsArray[1])
             { 
               optionDetail["content"]=detailsArray[1];
             }
             if(detailsArray[2])
             { 
               optionDetail["image"]=detailsArray[2];
             }            
              var textOption=this.documentXML[i].text;
              var textType="";
              if(textOption.texttype)
              {
                textType=textOption.texttype   
              }
             optionDetail["label"]=this.documentXML[i].name
             optionDetail["text"]=textType
             optionDetail["pic"]=this.documentXML[i].pic
             this.documentList.push(optionDetail);
            } else {
               let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",} 
               let detailsArray=detail["detail_"+(i+2)].split("@#^")
               if(detailsArray[0])
               {
                let optionsArray=detailsArray[0].split(",");
                let optionsLabel="";
                for(let j=0;j<optionsArray.length;j++)
                {
                  if(this.documentXML[i].optionList)
                  {
                  if(this.documentXML[i].optionList[optionsArray[j]])
                    {
                      //console.log(" option "+(i+1)+" "+(this.sSBXML[i].optionList[optionsArray[j]])); 
                      optionsLabel=optionsLabel+" "+this.documentXML[i].optionList[optionsArray[j]];
                    } 
                  }
                }
                optionDetail["option"]=optionsLabel;
               }
               if(detailsArray[1])
               { 
                 optionDetail["content"]=detailsArray[1];
               }
               if(detailsArray[2])
               { 
                 optionDetail["image"]=detailsArray[2];
               }            
                var textOption=this.documentXML[i].text;
                var textType="";
                if(textOption.texttype)
                {
                  textType=textOption.texttype   
                }
               optionDetail["label"]=this.documentXML[i].name
               optionDetail["text"]=textType
               optionDetail["pic"]=this.documentXML[i].pic
               if(this.documentXML[i].name!="Engine No" && this.documentXML[i].name!="Chasis No. Embossing") {
                this.documentList.push(optionDetail);
              }
            }
           }
         } 

         //Cooling system getting information 
         if(response.car_cooling_system[0])
         {
           let detail=response.car_cooling_system[0];
           for(let i=0;i<this.coolingSystemXML.length;i++)
           {   
           let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",}      
           if(detail["detail_"+(i+1)]) 
            {
             let detailsArray=detail["detail_"+(i+1)].split("@#^")
             if(detailsArray[0])
             {
              let optionsArray=detailsArray[0].split(",");
              let optionsLabel="";
              for(let j=0;j<optionsArray.length;j++)
              {
                if(this.coolingSystemXML[i].optionList)
                {
                if(this.coolingSystemXML[i].optionList[optionsArray[j]])
                {
                    //console.log(" option "+(i+1)+" "+(this.tyresXML[i].optionList[optionsArray[j]])); 
                    optionsLabel=optionsLabel+" "+this.coolingSystemXML[i].optionList[optionsArray[j]];
                  } 
                }
              }
              optionDetail["option"]=optionsLabel;
             }
             if(detailsArray[1])
             { 
               optionDetail["content"]=detailsArray[1];
             }
             if(detailsArray[2])
             { 
               optionDetail["image"]=detailsArray[2];
             }
             optionDetail["label"]=this.coolingSystemXML[i].name
             optionDetail["text"]=this.coolingSystemXML[i].text
             optionDetail["pic"]=this.coolingSystemXML[i].pic
            }
            this.coolingSystemList.push(optionDetail);
            console.log('DETAILS FOR VIEW');
            console.log(optionDetail);
            console.log('optionsArray optionsArray');
            //console.log(optionsArray);
           }         
         } else {
            let optionDetail={"label":"","option":"","content":"","image":"","text":"false","pic": "true",}     
            this.coolingSystemList.push(optionDetail);
         }
             
       }
       //console.log("this.exteriorFrontList "+(JSON.stringify(this.exteriorFrontList)));

       this.inspectionDetailStatus=true;       
       this.basicList=response.basic_list[0];
       //this.documentList=response.document_list[0];
       //this.exteriorList=response.car_exterior_front[0];
       //this.interiorList=response.interior_list[0];
       //this.engineList=response.engine_list[0];
       this.carHighlights=response.car_highlights[0];
       this.otherInspectionDetailsList=response.car_other_details[0];
       if(response.highlights)
        {
            this.highlights=response.highlights;        
        }

       let transmissionType:string=""; 
       if(this.basicList.transmissiontype)
       {
          if(this.basicList.transmissiontype.indexOf('1')>-1)
          {
             transmissionType=transmissionType+"AMT ";
          }
          else if(this.basicList.transmissiontype.indexOf('2')>-1)
          {
             transmissionType=transmissionType+"Automatic ";
          }
          else if(this.basicList.transmissiontype.indexOf('3')>-1)
          {
             transmissionType=transmissionType+"Manual ";
          }
          else if(this.basicList.transmissiontype.indexOf('4')>-1)
          {
             transmissionType=transmissionType+"Okay ";
          }
       }
       this.basicList.transmissiontype=transmissionType;
      
       let keys:string=""; 
       if(this.basicList.Keys_Keyless)
       {
          if(this.basicList.Keys_Keyless.indexOf('1')>-1)
          {
             keys=keys+"Keys ";
          }
          else if(this.basicList.Keys_Keyless.indexOf('2')>-1)
          {
             keys=keys+"Keyless ";
          }
       }
       this.basicList.Keys_Keyless=keys;
       
        //this.basicList.car_fuel_type_name=this.getFuelTypeFromId(this.basicList.car_fuel_type_id);
        var res = this.basicList.car_fuel_type_id.split(",");
        for (var i=0; i<res.length; i++)
        {
            res[i] = parseInt(res[i], 10);
        }
        let keys1:string=""; 
        for(var i=0; i<res.length; i++) {
            keys1= keys1+ this.getFuelTypeFromId(res[i]) + " ";
        }
        this.basicList.car_fuel_type_name= keys1;


        this.basicList.car_variants_name=this.getVariantFromId(this.basicList.car_variants);
        
        this.ratingCar=this.carHighlights.exterior_tyres+this.carHighlights.engine_transmission+this.carHighlights.air_conditioning+this.carHighlights.electricals_interiors+this.carHighlights.Steering_suspension_brakes
        if(this.ratingCar>0)
        {
          this.ratingCar=this.ratingCar/5;
        }        
     }
     else
     {
     show_okshan_alert3(response.reason);     
     } 
  }

 /** method used to show image */
  showImg(imgUrl)
  {
    show_img(imgUrl);
  }

  /** method used to show 2 image */
  showImg2(imgUrl1,imgUrl2)
  {
    show_img2(imgUrl1,imgUrl2);
  }

  /** getFuelTypeFromId function used to get fuel type from id  */
   getFuelTypeFromId(id)
   {
     if(this.sessionsService.getSession('all_fuel_type')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_fuel_type');
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   }

   /** getStateFromId function used to get state from id  */
   getStateFromId(id)
   {
     if(this.sessionsService.getSession('all_state')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_state');
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   }

   /** loadExteriorFrontXML function used to load exterior front xml */
  loadExteriorFrontXML()
  {
    let result =this.httpserviceService.loadExteriorFrontXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadExteriorFrontXMLResponse(data).then((data) => {  
           this.exteriorFrontXML = data;    
           //console.log("this.exteriorFrontXML "+JSON.stringify(this.exteriorFrontXML))        
          }),
     err => {
      //  this.isRequestInprocess=false; 
       // show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadExteriorFrontXMLResponse function used to handle response */
  loadExteriorFrontXMLResponse(data)
  {    
    console.log('loadExteriorFrontXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.exteriorFront;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList={};
          for (var m in select.option) {
          var option=select.option[m]
          optionList[option.bit[0]]=option.label[0];
          }
          //} 
          arr.push({  
            //id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }

  /** loadExteriorOtherXML function used to load exterior other xml */
  loadExteriorOtherXML()
  {
    let result =this.httpserviceService.loadExteriorOtherXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadExteriorOtherXMLResponse(data).then((data) => {  
           this.exteriorOtherXML = data;             
          }),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadExteriorOtherXMLResponse function used to handle response */
  loadExteriorOtherXMLResponse(data)
  {    
    console.log('loadExteriorOtherXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.exteriorOther;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          //optionList.push({"id":option.bit[0],"name":option.label[0]});
          optionList[option.bit[0]]=option.label[0];
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }




  /** coolingsystemXML function used to load tyres xml */
  loadCoolingSystemXML()
  {
      let result =this.httpserviceService.loadCoolingSystemXMLRequest().
      pipe(retry(0)).
      subscribe((data)=>this.loadCoolingSystemXMLResponse(data).then((data) => {  
           this.coolingSystemXML = data;           
          }),
        err => {
        //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
        console.log('Something went wrong ', err);       
    })
  }

  /** loadCoolingSystemXMLResponse function used to handle response */
  loadCoolingSystemXMLResponse(data)
  {    
      console.log('loadCoolingSystemXMLResponse '+ data);
      return new Promise(resolve => {  
        var k: string | number,  
          arr = [],  
          parser = new xml2js.Parser(  
            {  
              trim: true,  
              explicitArray: true  
            });  
          parser.parseString(data, function (err, result) {  
          var obj = result.coolingsystem;  
          for (k in obj.detail) { 
            var item = obj.detail[k]; 
            //for (m in item.select) {
            var select=item.select[0];
            var labelName=select.name[0];
            var optionList=[];
            for (var m in select.option) {
            var option=select.option[m]
              //optionList.push({"id":option.bit[0],"name":option.label[0]});
              optionList[option.bit[0]]=option.label[0];
            }
            //} 
            arr.push({  
              id: item.id[0],  
              name: labelName,  
              text: item.text[0],  
              pic: item.pic[0],
              image: "",
              optionList: optionList  
            });  
          }  
          resolve(arr);  
        });  
      });
  }




/** loadTyresXML function used to load tyres xml */
  loadTyresXML()
  {
    let result =this.httpserviceService.loadTyresXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadTyresXMLResponse(data).then((data) => {  
           this.tyresXML = data;           
          }),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadTyresXMLResponse function used to handle response */
  loadTyresXMLResponse(data)
  {    
    console.log('loadTyresXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.tyres;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          //optionList.push({"id":option.bit[0],"name":option.label[0]});
          optionList[option.bit[0]]=option.label[0];
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }

/** loadEngineXML function used to load engine xml */
  loadEngineXML()
  {
    let result =this.httpserviceService.loadEngineXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadEngineXMLResponse(data).then((data) => {  
           this.engineXML = data;           
          }),
     err => {
      //  this.isRequestInprocess=false; 
        //show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadEngineXMLResponse function used to handle response */
  loadEngineXMLResponse(data)
  {    
    console.log('loadEngineXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.engine;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          //optionList.push({"id":option.bit[0],"name":option.label[0]});
          optionList[option.bit[0]]=option.label[0];
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }

/** loadInteriorXML function used to load Interior xml */
  loadInteriorXML()
  {
    let result =this.httpserviceService.loadInteriorXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadInteriorXMLResponse(data).then((data) => {  
           this.interiorXML = data;             
          }),
     err => {
      //  this.isRequestInprocess=false; 
       // show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadInteriorXMLResponse function used to handle response */
  loadInteriorXMLResponse(data)
  {    
    console.log('loadInteriorXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.interior;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          //optionList.push({"id":option.bit[0],"name":option.label[0]});
          optionList[option.bit[0]]=option.label[0];
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }

/** loadACXML function used to load AC xml */
  loadACXML()
  {
    let result =this.httpserviceService.loadACXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadACXMLResponse(data).then((data) => {  
           this.aCXML = data;             
          }),
     err => {
      //  this.isRequestInprocess=false; 
       // show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadACXMLResponse function used to handle response */
  loadACXMLResponse(data)
  {    
    console.log('loadACXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.ac;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          //optionList.push({"id":option.bit[0],"name":option.label[0]});
          optionList[option.bit[0]]=option.label[0];
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }

/** loadSSBXML function used to load steering suspension and break xml */
  loadSSBXML()
  {
    let result =this.httpserviceService.loadSSBXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadSSBXMLResponse(data).then((data) => {  
           this.sSBXML = data;            
          }),
     err => {
      //  this.isRequestInprocess=false; 
       // show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadSSBXMLResponse function used to handle response */
  loadSSBXMLResponse(data)
  {    
    console.log('loadSSBXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.ssb;  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          //optionList.push({"id":option.bit[0],"name":option.label[0]});
          optionList[option.bit[0]]=option.label[0];
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }

  /** loadDocumentXML function used to load document xml */
  loadDocumentXML()
  {
    let result =this.httpserviceService.loadDocumentXMLRequest().
     pipe(retry(0)).
     subscribe((data)=>this.loadDocumentXMLResponse(data).then((data) => {  
           this.documentXML = data;            
          }),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** loadDocumentXMLResponse function used to handle response */
  loadDocumentXMLResponse(data)
  {    
    console.log('loadDocumentXMLResponse '+ data);
    return new Promise(resolve => {  
      var k: string | number,  
        arr = [],  
        parser = new xml2js.Parser(  
          {  
            trim: true,  
            explicitArray: true  
          });  
      parser.parseString(data, function (err, result) {  
        var obj = result.document  
        for (k in obj.detail) { 
          var item = obj.detail[k]; 
          //for (m in item.select) {
          var select=item.select[0];
          var labelName=select.name[0];
          var optionList=[];
          for (var m in select.option) {
          var option=select.option[m]
          //optionList.push({"id":option.bit[0],"name":option.label[0]});
          optionList[option.bit[0]]=option.label[0];
          }
          //} 
          arr.push({  
            id: item.id[0],  
            name: labelName,  
            text: item.text[0],  
            pic: item.pic[0],
            image: "",
            optionList: optionList  
          });  
        }  
        resolve(arr);  
      });  
    });  
    
  }

  setOkshanDetail()
  {
    for(let m=0;m<this.carDetail.length;m++)
    {
      let item=this.carDetail[m];
      if(item)
      {
       if(item.okshan_date && item.okshan_time && item.okshan_end_date && item.okshan_end_time)
       {
         if(item.okshan_date!="" && item.okshan_time!="" && item.okshan_end_date!="" && item.okshan_end_time!="")
            {
              let startAt = new Date(item.okshan_date+" "+item.okshan_time); 
              let endAt = new Date(item.okshan_end_date+" "+item.okshan_end_time);              
              this.okshanDetailList.push({"id":item.id,"startAt":startAt,"endAt":endAt});
            }
       }
       this.carDetail[m]=item;
       this.timerList[item.id]={};
       if(item.security_amount)
       {
       this.bidSecurityAmount=item.security_amount;
       this.joinOkshanFormGroup.controls["joinOkshanSecurity"].setValue(item.security_amount);
       }
       if(item.bid_start_value)
       {
       this.minBidAmount=item.bid_start_value;
       }
       if(item.bid_highest_value)
       {
       this.highestBidAmount=item.bid_highest_value;
       }             
      }      
    }
               setInterval(() => {
                this.setOkshanTimer(); 
                let dateNow = new Date();
                }, 1000);
  }

  setOkshanTimer()
  {
     for(let m=0;m<this.okshanDetailList.length;m++)
     {
      if(this.okshanDetailList[m].startAt && this.okshanDetailList[m].endAt) 
      {    
      let okshanDetail={};  
      let dateNow:any = new Date();
      let startAt:any=new Date(this.okshanDetailList[m].startAt)
      let endAt=new Date(this.okshanDetailList[m].endAt)
      if(dateNow>=startAt && dateNow<=endAt)
      {
      okshanDetail["status"]="live";
      }
      else if(dateNow<startAt)
      {
      okshanDetail["status"]="comming";
      let okshanStartIn="";      
      let seconds = Math.floor((startAt - (dateNow))/1000);
      let minutes = Math.floor(seconds/60);
      let hours = Math.floor(minutes/60);
      let days = Math.floor(hours/24);

      hours = hours-(days*24);
      minutes = minutes-(days*24*60)-(hours*60);
      seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
       
      if(days>0) 
      {
      if(days==1)
      {
      okshanStartIn="Starts In Day "+days+" "+hours+":"+minutes+":"+seconds;
      }
      else
      {
      okshanStartIn="Starts In Days "+days+" "+hours+":"+minutes+":"+seconds;
      }
      }
      else 
      {
      okshanStartIn="Starts In "+hours+":"+minutes+":"+seconds;
      }
      okshanDetail["startsIn"]=okshanStartIn;      
      }
      this.timerList[this.okshanDetailList[m].id]=okshanDetail;
       }
     }
  }

  /** saveBid function used to save bid */
  saveBid(data)
  {
   this.bidMsg="";
   this.isSubmitBid=true;
   if(this.bidFormGroup.valid)
   {
    if(this.highestBidAmount!='')
    {
      if(parseInt(data.bidAmount)<=parseInt(this.highestBidAmount))
      {
        this.bidMsg="Bid amount must more than highest bid amount";
        return false;
      }
      else
      {  
      this.router.navigate(['payment']);
      }
    }
    else if(this.minBidAmount!='')
    {
      if(parseInt(data.bidAmount)<=parseInt(this.minBidAmount))
      {
        this.bidMsg="Bid amount must more than minimum bid amount";
        return false;
      }
      else
      {  
      // let detail={"ev":"bid","amt": data.bidAmount,"sec":this.bidSecurityAmount,"car_id":this.id};
      // let requestData=btoa(JSON.stringify(detail));
      // this.router.navigate(['payment'], { queryParams: { qzwp: requestData } });
      let body={profile_id: this.sessionsService.getSession('id'), car_id:this.id , bid_amount:data.bidAmount, reserve_amount:this.bidSecurityAmount}
     let result =this.httpserviceService.saveBidDetailRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.saveBidDetailResponse(data), 
     err => {
       //show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    }) 
      }
    }    
   }
  }

  

  /** saveBidDetailResponse method used to handle response */
  saveBidDetailResponse(response)
  {
    console.log('saveBidDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       hide_modal('bid_now_modal');
       show_okshan_alert3("Detail is saved");       
     }
     else
     {
     show_okshan_alert3(response.reason);     
     } 
  }

  saveJoinOkshanAmount(data)
  {
   this.isSubmitJoinOkshan=true;
   if(this.joinOkshanFormGroup.valid)
   {   
      let detail={"ev":"jk","sec":this.bidSecurityAmount,"car_id":this.id};
      let requestData=btoa(JSON.stringify(detail));
      this.router.navigate(['payment'], { queryParams: { qzwp: requestData } });   
   }
  }

  /** function used to show alert   */
  showAlert(msg)
  {
    show_okshan_alert(msg);
  }

}
